// extracted by mini-css-extract-plugin
export default {"background":"Popup_background__2E5Jo","modalWrap":"Popup_modalWrap__m7uPP","contentWrap":"Popup_contentWrap__UZx3W"};